import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $http from './api/http/request'
import ErrorPlugin from './errorPlugin'
import VueClipboard from 'vue-clipboard2'
import Layout from '@/components/layout'
// 设置 js中可以访问 $cdn
// import { $cdn } from '@/config'
//
// Vue.prototype.$cdn = $cdn

// JS Bridge
import Bridge from './utils/bridge.js'
import './utils/vconsole.min.js'
// 全局变量
import global from '@/utils/global'

// 全局引入按需引入UI库
import plugins from '@/plugins/index'
// 引入全局样式
import '@/assets/css/index.scss'

// import Vant from 'vant'
// import 'vant/lib/index.css'
// Vue.use(Vant)
// 移动端适配
import 'lib-flexible/flexible.js'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

// filters
// import './filters'
// 开发环境及测试环境开启vconsole
if (process.env.NODE_ENV === 'development' || location.host === 'yuhunh5.mloveli.com' || location.host === '106.75.13.64:8890') {
  new VConsole()
}
Vue.component('Layout', Layout)
Vue.use(VueClipboard)
Vue.use(ErrorPlugin)
Vue.use(plugins)
Vue.config.productionTip = false
Vue.prototype.$http = $http
Vue.prototype.GLOBAL = global
Vue.prototype.$bridge = Bridge

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js